import { render, staticRenderFns } from "./AreaNotesForm.vue?vue&type=template&id=584f19f2&scoped=true"
import script from "./AreaNotesForm.vue?vue&type=script&lang=ts"
export * from "./AreaNotesForm.vue?vue&type=script&lang=ts"
import style0 from "./AreaNotesForm.vue?vue&type=style&index=0&id=584f19f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f19f2",
  null
  
)

export default component.exports